import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('userInfo', { $userInfo: 'userInfo' })
  },
  methods: {
    ...mapActions('userInfo', { getUserInfo: 'getUserInfo', setUserInfo: 'setUserInfo' })
  }
}
